import type { Company } from '@models/company'

export type FinancesTab = 'deliveryPayments' | 'driverDebts' | 'invoiceDebts'

interface FinancesTabConfig {
  tab: FinancesTab
  href: string
  enabled: boolean
}

// Order defines the default landing tab.
const getFinancesTabs = (company: Company): FinancesTabConfig[] => [
  {
    tab: 'deliveryPayments',
    href: `/companies/${company.id}/finances`,
    enabled: company.financesDeliveryPaymentsEnabled,
  },
  {
    tab: 'driverDebts',
    href: `/companies/${company.id}/finances/driverDebts`,
    enabled: company.financesDriverDebtsEnabled,
  },
  {
    tab: 'invoiceDebts',
    href: `/companies/${company.id}/finances/invoiceDebts`,
    enabled: company.financesInvoiceDebtsEnabled,
  },
]

export const getEnabledFinancesTabs = (company: Company) =>
  getFinancesTabs(company).filter(({ enabled }) => enabled)

export const getFirstEnabledFinancesTab = (company: Company) =>
  getEnabledFinancesTabs(company)[0]
